// src/components/Portfolio.jsx
import React, { useEffect, useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination, Autoplay } from "swiper/modules";
import api from "../services/httpService";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "swiper/css/autoplay";
import "./Portfolio.css";

const Portfolio = () => {
  const [portfolioData, setPortfolioData] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchPortfolio();
    fetchThemeColors();
  }, []);

  const fetchThemeColors = async () => {
    try {
      const res = await api.get("/sentinix/dashboardsettings");
      if (res.data.success && res.data.data) {
        const allData = Array.isArray(res.data.data) ? res.data.data : [res.data.data];
        const latest = allData.sort((a, b) => b.id - a.id)[0];
        if (latest) {
          document.documentElement.style.setProperty("--theme-color1", latest.color1 || "#f83600");
          document.documentElement.style.setProperty("--theme-color2", latest.color2 || "#fe8c00");
        }
      }
    } catch (err) {
      console.error("Error fetching theme colors:", err);
    }
  };

  const fetchPortfolio = async () => {
    try {
      const res = await api.get("/sentinix/portfolios");
      if (res.data.success) {
        const items = res.data.data.filter(
          (item) => item.type === "portfolio" && !item.isDeleted
        );
        setPortfolioData(items);
      }
    } catch (error) {
      console.error("Error fetching portfolio items:", error);
    } finally {
      setLoading(false);
    }
  };

  if (loading) return (
    <div style={{ textAlign: "center", padding: "3rem" }}>
      <div className="theme-spinner"></div>
      <p style={{ marginTop: "1rem" }}>Loading portfolio...</p>
    </div>
  );

  return (
    <div className="portfolio-section">
      {/* Section Title */}
      <div className="portfolio-heading">
        <h2 className="theme-gradient-text">Our Portfolio</h2>
        <p className="portfolio-sub">Explore some of our projects.</p>
      </div>

      {/* Swiper */}
      <Swiper
        modules={[Navigation, Pagination, Autoplay]}
        spaceBetween={24}
        loop={true}
        navigation
        pagination={{ clickable: true }}
        autoplay={{ delay: 3000, disableOnInteraction: false }}
        breakpoints={{
          0:    { slidesPerView: 1 },
          768:  { slidesPerView: 2 },
          1024: { slidesPerView: 3 },
        }}
        className="portfolio-swiper"
      >
        {portfolioData.map((item) => (
          <SwiperSlide key={item.id} className="portfolio-slide">
            {/* ✅ Pure CSS card — no MUI Box/Card sizing conflicts */}
            <div className="portfolio-card">
              <div className="portfolio-card-top-bar" />
              {item.imageKey && (
                <img
                  src={item.imageKey}
                  alt={item.title}
                  className="portfolio-card-img"
                />
              )}
              <div className="portfolio-card-body">
                <h3 className="portfolio-card-title">{item.title}</h3>
                <p className="portfolio-card-desc">{item.description}</p>
              </div>
            </div>
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  );
};

export default Portfolio;